<template>
  <div class="search-product">
    <div class="search-field">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M16.5 16.5L21 21" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10Z" stroke="#1B78BC" stroke-width="1.5" stroke-linejoin="round"/>
      </svg>
      <input
          :value="value" @input="updateValue"
          @change="search"
          :placeholder="placeholder">
      <button @click="search()">Найти</button>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'SearchField',
  props : {
    placeholder : String,
    type: String,
  },
  components: {

  },
  data() {
    return{
      value : this.$route.query.q
    }
  },
  methods : {
    updateValue(e) {
      this.value = e.target.value;
    },
    search : function() {
      if(this.type == "catalog")
      {
        if(this.value == undefined) { this.value = ""; }
        window.location.href = "/lk/catalog/search?q=" + this.value;
      }
      else
      {
        this.$router.push({query: {q: this.value}});
      }
    },
  }
}
</script>

<style scoped>

.search-product {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  width: 100%;
}

.search-field {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 4px 4px 4px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
}

.search-field input {
  outline: none;
  border: none;
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  flex: 1;
}

.search-field button {
  outline: none;
  border: none;
  border-radius: 8px;
  background: var(--Blue, #1B78BC);
  padding: 11px 30px;

  color: var(--White, #FFF);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 118%;

  cursor: pointer;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .search-product {

  }

  .search-product {
    margin-bottom: 12px;
  }

  .search-field {
    padding: 4px 4px 4px 30px;
  }

  .search-field input{
    width: 100%;
  }

  .search-field button {
    padding: 11px 16px;
  }


}
</style>

<style>
/*MOBILE*/
@media (max-width: 1250px)
{
  .white.w262 {
    display: none;
  }
}
</style>

